export const CONTRIBUTION_STATUS = {
  REVIEWED: "reviewed",
  PENDING: "pending",
  NEEDS_CHANGES: "needs_changes",
  REJECTED: "rejected",
  REPLACED: "replaced",
} as const;

export const STATUS_LABELS: Record<string, string> = {
  [CONTRIBUTION_STATUS.REVIEWED]: "Reviewed",
  [CONTRIBUTION_STATUS.PENDING]: "Under Review",
  [CONTRIBUTION_STATUS.NEEDS_CHANGES]: "Needs Changes",
  [CONTRIBUTION_STATUS.REJECTED]: "Rejected",
  [CONTRIBUTION_STATUS.REPLACED]: "Reviewed",
};

export const STATUS_COLORS: Record<string, string> = {
  [CONTRIBUTION_STATUS.REVIEWED]: "#74CE6A",
  [CONTRIBUTION_STATUS.PENDING]: "#F2B12F",
  [CONTRIBUTION_STATUS.REPLACED]: "#74CE6A",
  DEFAULT: "#F45151", // For rejected, needs_changes, or unknown
};

export const getStatusColor = (status: string) => {
  const s = status.toLowerCase();
  if (s.includes("reviewed") || s === CONTRIBUTION_STATUS.REPLACED) return STATUS_COLORS[CONTRIBUTION_STATUS.REVIEWED];
  if (s === CONTRIBUTION_STATUS.PENDING) return STATUS_COLORS[CONTRIBUTION_STATUS.PENDING];
  return STATUS_COLORS.DEFAULT;
};

export const getStatusLabel = (status: string) => {
  return STATUS_LABELS[status.toLowerCase()] || "Unknown";
};
